const chillout = require('chillout');
/**
 * カタログのサイズ調整
 * 
 */
const resizeCataloguePc = (ratio) => {

	const catalogue = document.getElementById('js-pc-catalogue');
	const catalogueList = document.getElementById('js-pc-catalogue-list');
	const catalogueWidth = catalogue.clientWidth;
	const catalogueHeight = catalogue.clientHeight;

	const containerRatio = catalogueWidth / catalogueHeight;


	// 表紙
	let cover = document.getElementById('js-pc-cover');

	/**
	 * 縦横比によって表紙のサイズを変える
	 */
	if (containerRatio > ratio) {
		catalogue.classList.remove('pc-catalogue-content--narrow-width');
		cover.style.width = '';
		cover.style.height = '';
	} else {
		catalogue.classList.add('pc-catalogue-content--narrow-width');
		cover.style.width = (catalogueWidth / 2) + 'px';
		cover.style.height = (catalogueWidth / ratio ) + 'px';
	}

	/**
	 * 表紙のサイズに応じて、親要素、残りのページのサイズを設定する
	 */
	// 表紙のサイズが変わっているので再取得
	cover = document.getElementById('js-pc-cover');

	const coverImg = document.getElementById('js-pc-cover-img');

	const coverImgWidth = coverImg.clientWidth;
	const coverImgHeight = coverImg.clientHeight;

	catalogueList.style.width = coverImgWidth * 2 + 'px';
	catalogueList.style.height = coverImgHeight + 'px';

	// 各ページ
	const cataloguePages = document.getElementsByClassName('pc-catalogue-list__page');

	// 各ページのサイズを表紙に合わせる
	chillout.forEach([...cataloguePages], elem => {

		if (elem.id !== 'js-pc-cover') {

			elem.style.width = coverImgWidth + 'px';
			elem.style.height = coverImgHeight + 'px';
		}
	});
	/* [...cataloguePages].forEach((elem) => {
		if (elem.id !== 'js-pc-cover') {
			
			elem.style.width = coverImgWidth + 'px';
			elem.style.height = coverImgHeight + 'px';
		}
	}); */
}

function isPinchZooming() {
	return window.visualViewport.scale > 1
}

/**
 * カタログが読み込み済みか確認するための変数
 * 関数の重複実行を防ぐ
 */
let isCatalogueLoaded = false;

let currentItemNum = 0;
let currentPageNum = 0;

const CataloguePc = () => {

	let ratio;

	const catalogueWrap = document.getElementById('js-catalogue-wrap');

	catalogueWrap.style.height = '';

	const inputCurrentNum = document.getElementById('js-pc-current-num');
	inputCurrentNum.value = currentPageNum;

	const coverImg = document.querySelector('.pc-catalogue-list__page--cover img');

	const loadEvent = () => {

		const coverImg = document.getElementById('js-pc-cover-img');

		const coverImgWidth = coverImg.clientWidth;
		const coverImgHeight = coverImg.clientHeight;

		ratio = coverImgWidth * 2 / coverImgHeight; // カタログの比率取得
		resizeCataloguePc(ratio);
	}

	const userAgent = window.navigator.userAgent.toLowerCase();

	if (userAgent.indexOf('edge') != -1) {
		window.addEventListener('load', () => {

			loadEvent();
		});
	} else {
		coverImg.addEventListener('load', () => {

			loadEvent();
		});
	}

	const CatalogueLoad = () => {
		const catalogueItems = document.getElementsByClassName('pc-catalogue-list__item');
		const cataloguePages = document.getElementsByClassName('pc-catalogue-list__page');
		const notEmptyPages = document.querySelectorAll('.pc-catalogue-list__page:not(.pc-catalogue-list__page--empty)');
		const catalogueContent = document.getElementById('js-pc-catalogue');
		const catalogueList = document.getElementById('js-pc-catalogue-list');

		const changeListBtn = document.getElementById('js-pc-catalogue-list-btn');

		const totalPageNumSpan = document.getElementById('js-pc-total-num');
		const totalPageNum = notEmptyPages.length - 1;

		const coverImg = document.getElementById('js-pc-cover-img');

		const coverImgWidth = coverImg.clientWidth;
		const coverImgHeight = coverImg.clientHeight;

		// eslint-disable-next-line no-undef
		const iconPath = tmgcJsValue.path + 'dist/images/icons/';

		ratio = coverImgWidth * 2 / coverImgHeight; // カタログの比率取得

		resizeCataloguePc(ratio);

		const catalogeInitialize = () => {
			catalogueContent.classList.remove('pc-catalogue--list');
			// resizeCataloguePc(ratio);
			changeListBtn.innerHTML = `<img src="${iconPath}list-icon.svg" alt="一覧表示" width="19" height="19" />一覧表示`;
		}
		catalogeInitialize();

		inputCurrentNum.max = totalPageNum;

		window.addEventListener('resize', () => {
			
			if (isPinchZooming()) return;

			if (catalogueContent.classList.contains('pc-catalogue--list')) return;
			resizeCataloguePc(ratio);
		});

		chillout.forEach([...notEmptyPages], (elem, index) => {
			elem.dataset.itemNum = index;
		});

		/* [...notEmptyPages].forEach((elem, index) => {
			elem.dataset.itemNum = index;
		}) */

		/**
		 * 現在のページと次のページにクラスを追加
		 */
		const currentItem = catalogueItems[currentItemNum];
		currentItem.classList.add('pc-catalogue-list__item--current-item');

		const currentItemNext = currentItem.nextElementSibling;
		if (currentItemNext) {
			currentItemNext.classList.add('pc-catalogue-list__item--next');
		}

		const changeDisabled = num => {
			/**
			 * 現在のページでボタン操作できるか判定
			 */
			const prevButton = document.getElementById('js-pc-catalogue-prev-btn');
			const nextButton = document.getElementById('js-pc-catalogue-next-btn');

			const moveFirstBtn = document.getElementById('js-pc-catalogue-first-btn');
			const moveLastBtn = document.getElementById('js-pc-catalogue-last-btn');

			if (num === 0) {
				prevButton.disabled = true;
				moveFirstBtn.disabled = true;
			} else {
				prevButton.disabled = false;
				moveFirstBtn.disabled = false;
			}

			if (num === totalPageNum || (totalPageNum % 2 === 0 && num === totalPageNum - 1)) {
				nextButton.disabled = true;
				moveLastBtn.disabled = true;
			} else {
				nextButton.disabled = false;
				moveLastBtn.disabled = false;
			}
		}

		const changeInputNum = (num) => {

			inputCurrentNum.value = num;

			changeDisabled(num);
		}

		/**
		 * 現在のページ番号とページ数を表示
		 */
		changeInputNum(currentPageNum);
		totalPageNumSpan.innerText = totalPageNum;

		/**
		 * アニメーションするページの対象を変えるためにクラスを一旦削除
		 */
		const removeMoveClass = () => {

			/* chillout.forEach([...cataloguePages], (elem) => {
				elem.classList.remove('pc-catalogue-list__page--move');
				elem.classList.remove('pc-catalogue-list__page--shadow');
			});

			chillout.forEach([...catalogueItems], (elem) => {
				elem.classList.remove('pc-catalogue-list__item--move');
			}); */
			[...cataloguePages].forEach((elem) => {
				elem.classList.remove('pc-catalogue-list__page--move');
				elem.classList.remove('pc-catalogue-list__page--shadow');
			});

			[...catalogueItems].forEach((elem) => {
				elem.classList.remove('pc-catalogue-list__item--move');
			})
		}

		/**
		 * 一旦クラス削除
		 */
		const removeItemClass = () => {
			/* chillout.forEach([...catalogueItems], (elem) => {
				elem.classList.remove('pc-catalogue-list__item--current-item');
				elem.classList.remove('pc-catalogue-list__item--next');
				elem.classList.remove('pc-catalogue-list__item--prev');
			}); */

			[...catalogueItems].forEach((elem) => {
				elem.classList.remove('pc-catalogue-list__item--current-item');
				elem.classList.remove('pc-catalogue-list__item--next');
				elem.classList.remove('pc-catalogue-list__item--prev');
			})
		}

		const movePrevItem = (elem) => {
			const parent = elem.parentNode;

			parent.classList.remove('pc-catalogue-list__item--start');

			/**
			 * 左をクリックする
			 * →現在のページがnextになる
			 * →前のページがcurrentになる
			 * →さらに次前のページがcurrentになる
			 * →次のページのnextを削除
			 */
			const prev = parent.previousElementSibling;
			const next = parent.nextElementSibling;

			if (prev) {
				// 現在のページがcurrentではなくなる
				parent.classList.remove('pc-catalogue-list__item--current-item');
				prev.classList.add('pc-catalogue-list__item--current-item');
				prev.classList.remove('pc-catalogue-list__item--prev');
			} else {
				// 前のページがなければ処理を終了
				return;
			}

			parent.classList.add('pc-catalogue-list__item--next');
			parent.classList.add('pc-catalogue-list__item--move');

			const prevPages = prev.children;

			if (prevPages[1]) {
				prevPages[1].classList.add('pc-catalogue-list__page--move');
			}
			if (prevPages[0]) {
				prevPages[0].classList.add('pc-catalogue-list__page--shadow');
			}

			if (next) {
				next.classList.remove('pc-catalogue-list__item--next');
			}

			const prev2 = prev.previousElementSibling;

			if (prev2) {
				prev2.classList.add('pc-catalogue-list__item--prev');
			}

			if (currentPageNum == elem.getAttribute('data-item-num')) {
				currentPageNum -= 2;

				if (currentPageNum < 0) {
					currentPageNum = 0;
					
				} else if (currentPageNum % 2 === 0 && currentPageNum !== 0) {
					currentPageNum -= 1;
				}

				changeInputNum(currentPageNum);
			} else if (currentPageNum === totalPageNum && totalPageNum % 2 === 0) {
				currentPageNum -= 3;

				changeInputNum(currentPageNum);
			} 
		}

		const moveNextItem = (elem) => {
			const parent = elem.parentNode;
			parent.classList.remove('pc-catalogue-list__item--start');

			/**
			 * 右をクリックする
			 * →現在のページがprevになる
			 * →次のページがnextからcurrentになる
			 * →さらに次のページがnextになる
			 * →前のページのprevを削除
			 */
			const next = parent.nextElementSibling;
			const prev = parent.previousElementSibling;

			if (next) {
				// 現在のページがcurrentではなくなる
				parent.classList.remove('pc-catalogue-list__item--current-item');
				next.classList.add('pc-catalogue-list__item--current-item');
				next.classList.remove('pc-catalogue-list__item--next');
			} else {
				// 前のページがなければ処理を終了
				return;
			}

			parent.classList.add('pc-catalogue-list__item--prev');
			parent.classList.add('pc-catalogue-list__item--move');

			const nextPages = next.children;

			if (nextPages[0]) {
				nextPages[0].classList.add('pc-catalogue-list__page--move');
			}

			if (nextPages[1]) {
				nextPages[1].classList.add('pc-catalogue-list__page--shadow');
			}

			if (prev) {
				prev.classList.remove('pc-catalogue-list__item--prev');
			}

			const next2 = next.nextElementSibling;

			if (next2) {
				next2.classList.add('pc-catalogue-list__item--next');
			}

			let useChangeInputNum = false;

			if (currentPageNum === 0) {
				
				if (currentPageNum == elem.getAttribute('data-item-num')) {
					useChangeInputNum = true;
				}

			} else {
				
				if (currentPageNum + 1 == elem.getAttribute('data-item-num') || currentPageNum === totalPageNum) {
					useChangeInputNum = true;
				}
			}
			

			if (useChangeInputNum) {
				currentPageNum += 2;

				if (currentPageNum % 2 === 0) currentPageNum -= 1;

				changeInputNum(currentPageNum);
			}
		}

		/* chillout.forEach([...cataloguePages], (elem) => {

			elem.addEventListener('click', function () {

				if (catalogueContent.classList.contains('pc-catalogue--list')) return;

				removeMoveClass();

				if (this.classList.contains('pc-catalogue-list__page--left')) {

					movePrevItem(this);

				} else {

					moveNextItem(this);

				}
			});
		}); */

		[...cataloguePages].forEach((elem) => {

			elem.addEventListener('click', function () {

				if (catalogueContent.classList.contains('pc-catalogue--list')) return;

				removeMoveClass();

				if (this.classList.contains('pc-catalogue-list__page--left')) {

					movePrevItem(this);

				} else {

					moveNextItem(this);

				}
			});
		});

		/**
		 * タッチイベント
		 */
		let touchStartX = 0;
		let touchEndX = 0;

		if (catalogueList.dataset.touchstartEvent !== 'added') {
			catalogueList.addEventListener('touchstart', e => {

				catalogueList.dataset.touchstartEvent = 'added';

				if (isPinchZooming()) return;

				if (catalogueContent.classList.contains('pc-catalogue--list')) return;
				if (catalogueList.classList.contains('pc-catalogue-list--zoom')) return;

				touchStartX = e.changedTouches[0].clientX;
			});
		}

		if (catalogueList.dataset.touchendEvent !== 'added') {
			catalogueList.addEventListener('touchend', e => {

				catalogueList.dataset.touchendEvent = 'added';

				if (isPinchZooming()) return;

				if (catalogueContent.classList.contains('pc-catalogue--list')) return;
				if (catalogueList.classList.contains('pc-catalogue-list--zoom')) return;

				touchEndX = e.changedTouches[0].clientX;

				if (touchStartX - touchEndX > 30) {

					const currentRightPage = document.querySelector('.pc-catalogue-list__item--current-item .pc-catalogue-list__page--right');
					
					removeMoveClass();
					moveNextItem(currentRightPage);

				} else if (touchStartX - touchEndX < -30) {

					const currentLeftPage = document.querySelector('.pc-catalogue-list__item--current-item .pc-catalogue-list__page--left');

					removeMoveClass();
					movePrevItem(currentLeftPage);

				}
			});
		}
		

		/**
		 * コントローラーを操作した時の処理
		 */

		// 戻るボタン、進むボタン
		const prevButton = document.getElementById('js-pc-catalogue-prev-btn');
		const nextButton = document.getElementById('js-pc-catalogue-next-btn');

		if (prevButton.dataset.eventAdded !== 'added') {
			prevButton.addEventListener('click', () => {
				prevButton.dataset.eventAdded = 'added';

				if (catalogueContent.classList.contains('pc-catalogue--list')) return;

				const currentLeftPage = document.querySelector('.pc-catalogue-list__item--current-item .pc-catalogue-list__page--left');

				removeMoveClass();
				movePrevItem(currentLeftPage);
			});
		}
		

		if (nextButton.dataset.eventAdded !== 'added') {
			nextButton.addEventListener('click', () => {
				nextButton.dataset.eventAdded = 'added';

				if (catalogueContent.classList.contains('pc-catalogue--list')) return;

				const currentRightPage = document.querySelector('.pc-catalogue-list__item--current-item .pc-catalogue-list__page--right');

				removeMoveClass();
				moveNextItem(currentRightPage);
			});
		}

		/**
		 * 指定の番号をセットしてクラスを付ける
		 */
		const setClassSpecifyItem = (num) => {
			const targetItem = catalogueItems[num];

			const prevItem = targetItem.previousElementSibling;
			const nextItem = targetItem.nextElementSibling;

			targetItem.classList.add('pc-catalogue-list__item--current-item');

			if (nextItem) {
				nextItem.classList.add('pc-catalogue-list__item--next');
			}

			if (prevItem) {
				prevItem.classList.add('pc-catalogue-list__item--prev');
			}
		}

		/**
		 * 指定の番号をセットして移動させる関数
		 */
		const moveSpecifyItem = () => {
			removeMoveClass();
			removeItemClass();

			let specifyPage = parseInt(inputCurrentNum.value, 10);

			if (specifyPage < 0) {
				specifyPage = 0;
			} else if (specifyPage > totalPageNum) {
				specifyPage = totalPageNum;
			}

			currentPageNum = specifyPage;

			changeInputNum(currentPageNum);

			if (specifyPage % 2 !== 0) {
				/**
				 * 奇数
				 * 1 = (1 + 1) / 2
				 * 2 = (3 + 1) / 2
				 * 3 = (5 + 1) / 2
				 * ...
				 *
				 * アイテム番号 = (ページ番号 + 1) / 2
				 */
				const pageNum = (specifyPage + 1) / 2;

				setClassSpecifyItem(pageNum);

			} else {
				/**
				 * 偶数
				 * 
				 * アイテム番号 = ページ番号 / 2
				 */
				const pageNum = specifyPage / 2;

				setClassSpecifyItem(pageNum);
			}
		}

		// 最初に戻るボタン
		const moveFirstBtn = document.getElementById('js-pc-catalogue-first-btn');

		if (moveFirstBtn.dataset.eventAdded !== 'added') {
			moveFirstBtn.addEventListener('click', () => {

				moveFirstBtn.dataset.eventAdded = 'added';

				if (catalogueContent.classList.contains('pc-catalogue--list')) return;

				removeMoveClass();
				removeItemClass();

				currentPageNum = 0;
				setClassSpecifyItem(currentPageNum);
				changeInputNum(0);
			});
		}


		// 最後に進むボタン
		const moveLastBtn = document.getElementById('js-pc-catalogue-last-btn');

		if (moveLastBtn.dataset.eventAdded !== 'added') {
			moveLastBtn.addEventListener('click', () => {

				moveLastBtn.dataset.eventAdded = 'added';

				if (catalogueContent.classList.contains('pc-catalogue--list')) return;

				removeMoveClass();
				removeItemClass();

				currentPageNum = totalPageNum;

				if (totalPageNum % 2 !== 0) {
					const itemNum = (totalPageNum + 1) / 2;

					setClassSpecifyItem(itemNum);
				} else {
					const itemNum = totalPageNum / 2;

					setClassSpecifyItem(itemNum);
				}
				changeInputNum(totalPageNum);
			})
		}

		// ページ指定遷移ボタン
		const setClassSpecifyItemBtn = document.getElementById('js-pc-catalogue-move-btn');

		if (setClassSpecifyItemBtn.dataset.eventAdded !== 'added') {
			setClassSpecifyItemBtn.addEventListener('click', () => {

				setClassSpecifyItemBtn.dataset.eventAdded = 'added';

				if (catalogueContent.classList.contains('pc-catalogue--list')) {
					catalogueContent.classList.remove('pc-catalogue--list');

					resizeCataloguePc(ratio);

					changeListBtn.innerHTML = `<img src="${iconPath}list-icon.svg" alt="一覧表示" width="19" height="19" />一覧表示`;
				}

				moveSpecifyItem();
			});
		}


		/**
		 * リストボタンをクリックした時の挙動
		 */

		if (changeListBtn.dataset.eventAdded !== 'added') {
			changeListBtn.addEventListener('click', function () {

				changeListBtn.dataset.eventAdded = 'added';

				if (catalogueContent.classList.contains('pc-catalogue--list')) {
					catalogueContent.classList.remove('pc-catalogue--list');
					resizeCataloguePc(ratio);
					changeListBtn.innerHTML = `<img src="${iconPath}list-icon.svg" alt="一覧表示" width="19" height="19" />一覧表示`;
				} else {
					catalogueList.classList.remove('pc-catalogue-list--zoom');
					catalogueContent.classList.remove('pc-catalogue-content--zoom');

					catalogueContent.classList.add('pc-catalogue--list');

					catalogueList.style.width = '';
					catalogueList.style.height = '';

					changeListBtn.innerHTML = `<img src="${iconPath}page-icon.svg" alt="ページ表示" width="19" height="19" />ページ表示`;

					chillout.forEach([...catalogueItems], elem => {
						elem.classList.remove('pc-catalogue-list__item--move');
					});
					chillout.forEach([...cataloguePages], elem => {
						elem.classList.remove('pc-catalogue-list__page--move');
						elem.style.width = '';
						elem.style.height = '';
					});

					/* [...catalogueItems].forEach(elem => {
						elem.classList.remove('pc-catalogue-list__item--move');
					});

					[...cataloguePages].forEach(elem => {
						elem.classList.remove('pc-catalogue-list__page--move');
						elem.style.width = '';
						elem.style.height = '';
					}); */
				}
			});
		}

		/* chillout.forEach([...notEmptyPages], (elem) => {
			elem.addEventListener('click', function () {
				if (catalogueContent.classList.contains('pc-catalogue--list')) {

					currentPageNum = parseInt(this.dataset.itemNum, 10);
					inputCurrentNum.value = currentPageNum;

					catalogueContent.classList.remove('pc-catalogue--list');
					changeListBtn.innerHTML = `<img src="${iconPath}list-icon.svg" alt="一覧表示" width="19" height="19" />一覧表示`;

					moveSpecifyItem();
					resizeCataloguePc(ratio);
				}
			});
		}); */

		[...notEmptyPages].forEach((elem) => {
			elem.addEventListener('click', function () {
				if (catalogueContent.classList.contains('pc-catalogue--list')) {

					currentPageNum = parseInt(this.dataset.itemNum, 10);
					inputCurrentNum.value = currentPageNum;

					catalogueContent.classList.remove('pc-catalogue--list');
					changeListBtn.innerHTML = `<img src="${iconPath}list-icon.svg" alt="一覧表示" width="19" height="19" />一覧表示`;

					moveSpecifyItem();
					resizeCataloguePc(ratio);
				}
			});
		});

		/**
		 * 拡大・縮小ボタンをクリックした時の挙動
		 */
		const zoomInBtn = document.getElementById('js-pc-catalogue-zoom-in-btn');

		if (zoomInBtn.dataset.eventAdded !== 'added') {
			zoomInBtn.addEventListener('click', function () {

				zoomInBtn.dataset.eventAdded = 'added';

				if (catalogueContent.classList.contains('pc-catalogue--list')) return;

				catalogueList.classList.add('pc-catalogue-list--zoom');
				catalogueContent.classList.add('pc-catalogue-content--zoom');

				catalogueWrap.classList.add('catalogue-wrap--list');
			});
		}
		

		const zoomOutBtn = document.getElementById('js-pc-catalogue-zoom-out-btn');

		if (zoomOutBtn.dataset.eventAdded !== 'added') {
			zoomOutBtn.addEventListener('click', function () {

				zoomOutBtn.dataset.eventAdded = 'added';

				if (catalogueContent.classList.contains('pc-catalogue--list')) return;

				catalogueList.classList.remove('pc-catalogue-list--zoom');
				catalogueContent.classList.remove('pc-catalogue-content--zoom');

				catalogueWrap.classList.add('catalogue-wrap--list');
			});
		}
		

		// スマホサイズ→PCサイズに切り替わった時の処理
		const mediaQuery = window.matchMedia('(min-width: 769px)');

		const handle = (mq) => {
			if (mq.matches) {
				moveSpecifyItem();
			}
		}

		handle(mediaQuery);

		mediaQuery.addListener(handle);

		isCatalogueLoaded = true;
	}

	/**
	 * ロード時にカタログの生成を発動
	 */
	if(!isCatalogueLoaded) {
		CatalogueLoad();
	}
}
export default CataloguePc;